import { CircleInfoIcon } from '@p2p/assets/svg';

import { BankCard } from '../BankCard';
import { BankCardSkeleton } from '../BankCardSkeleton';
import styles from './TBankInfoBlock.module.scss';

type TBankInfoBlockProps = {
  bankName: string;
  bankLogoSrc: string;
  fio: string;
};

export const TBankInfoBlock = ({ bankName, bankLogoSrc, fio }: TBankInfoBlockProps) => {
  return (
    <div className={styles.container}>
      <header className={styles.headerContainer}>
        <CircleInfoIcon className={styles.headerIcon} />
        <h3 className={styles.title}>
          Выберите <span className={styles.bold}>{bankName}</span> при переводе
        </h3>
      </header>

      <div className={styles.infoBlocksContainer}>
        <BankCard bankName={bankName} fio={fio} imgSrc={bankLogoSrc} />
        <BankCardSkeleton />
        <BankCardSkeleton />
      </div>
    </div>
  );
};
